
import WeeklyReportMixin from '@/mixins/ProjectManagement/WeeklyReportMixin';
import { Component } from 'vue-property-decorator';

import Background1SVG from '@/assets/Photo1Background.svg';
import Background2SVG from '@/assets/Photo2Background.svg';
import Background3SVG from '@/assets/Photo3Background.svg';
import Background4SVG from '@/assets/Photo4Background.svg';

import Title1SVG from '@/assets/Photo1Title.svg';
import Title2SVG from '@/assets/Photo2Title.svg';
import Title3SVG from '@/assets/Photo3Title.svg';
import Title4SVG from '@/assets/Photo4Title.svg';

import PhotoTopLeftIcon from '@/assets/Photo1.svg';
import PhotoTopRightIcon from '@/assets/Photo2.svg';
import PhotoBottomRightIcon from '@/assets/Photo3.svg';
import PhotoBottomLeftIcon from '@/assets/Photo4.svg';
import ImageUploader from '@/components/Image/ImageUploader.vue';

@Component({
    components: {
        Background1SVG,
        Background2SVG,
        Background3SVG,
        Background4SVG,
        Title1SVG,
        Title2SVG,
        Title3SVG,
        Title4SVG,
        PhotoTopLeftIcon,
        PhotoTopRightIcon,
        PhotoBottomLeftIcon,
        PhotoBottomRightIcon,

        ImageUploader,
    },
})
export default class ConstructionProgressPage extends WeeklyReportMixin {}
